import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-11-09'
        tag='Depop'
        title='Depop Shipping 2022 - The Simple Guide to Depop Shipping your Sales'
      >
        <h3>You Sold an Item! What to Do Next?</h3>
        <p>
          Before we dive right into shipping and packaging costs, let's first discuss the basics of what to do after you
          sell an item on Depop.
        </p>

        <h4>Step 1: Contact Your Buyer</h4>
        <p>
          You can message the buyer to inform them that you have seen their orders and you'll ship them as soon as
          possible. You can send them the photo of the actual item to ensure accuracy and let them know if there are
          flaws or damages on the items they just purchased. In this way, you build a positive relationship between the
          buyer and you as the seller. They will also be able to trust you more after you make an engagement,
          potentially leading to another future sale!
        </p>

        <h4>Step 2: Start Shipping!</h4>
        <p>
          After reaching out to your customer, prepare your package by packing it securely and choosing your preferred
          courier. For U.S. sellers, Depop offers an in-app courier (USPS). If you are a seller living outside the
          mainland USA, you can still send your package using your local postal service that offers proof of delivery.
        </p>
        <p>Depop Shipping Guide for U.S. Sellers:</p>
        <p>
          If you are a Depop seller from the U.S., you have two shipping options to arrange the shipping of your sold
          items.
        </p>
        <ul>
          <li>
            Arrange it on your own: You can arrange your own shipping by going to your local post office or purchasing a
            shipping label through a third party such as UPS.
          </li>
          <li>Arrange with Depop: You can arrange your shipping through the Depop in-app courier (USPS)</li>
        </ul>
        <p>
          Remember to always use tracked shipping whenever possible. Untracked parcels give you no guarantee on the
          current status of the shipping, plus they are not covered under Depop's or PayPal's Seller Protection policy.
          Always choose the best option where you and your buyer can be protected!
        </p>

        <h4>Step 3: Mark Your Listing as Shipped!</h4>
        <p>
          As soon as you ship the item, contact your buyer with its tracking number. This helps build trust from your
          buyers and gives them assurance on when they can expect the item's arrival.
        </p>

        <h4>Step 4: Give Your Buyer a Review!</h4>
        <p>
          After the item arrives at your buyers' shipping address and the transaction has been completed, give your
          buyer a review and encourage them to do the same to your shop. Generating more positive reviews help build
          your shop's credibility and attract more buyers.
        </p>

        <h3>Domestic and International Shipping Fees</h3>
        <p>
          Depop is a free shopping app that allows people to buy and sell items in their area. The shopping app includes
          tools such as the shopping bag, which provides information on shipping costs. However, it does not always show
          precise cuts on the actual shipping prices.
        </p>
        <p>
          Depop uses USPS as its in-app courier to ship within the shopping app. Keep in mind that domestic or
          international shipping prices are based on the size and weight of the item and how far its destination is from
          the place of origin. The prices vary, so sellers need to determine their pricing before posting a product on
          the app.
        </p>
        <p>
          If you are unsure how much the shipping cost will be, it is essential to know your items' measurement, weight,
          and destination. Here are some estimated prices that Depop provides for different items:
        </p>
        <ul>
          <li>For dresses: 4-10 (£/$/€)</li>
          <li>For tops: 3-8 (£/$/€)</li>
          <li>For outerwear: 8-20 (£/$/€)</li>
          <li>For pants or jeans: 5-10 (£/$/€)</li>
          <li>For shoes: 8-20 (£/$/€)</li>
          <li>For makeup, jewelry, or small items: 3-5 (£/$/€)</li>
          <li>If you're shipping worldwide: 10-30 (£/$/€)</li>
        </ul>
        <p>
          <strong>Pro Tip</strong>: You can choose whether you want to sell your items domestically or internationally.
          Remember that international shipping is expensive, but it increases your market and gives you a higher chance
          of selling fast.
        </p>

        <h3>Domestic Shipping with Depop In-App Courier</h3>
        <p>
          As a seller, you are always responsible for shipping the item once it's sold. You can also choose which
          courier you want to use or how you want the items delivered to your buyers. Here's the step-by-step guide on
          doing that:
        </p>
        <ol>
          <li>Tap "Delivery," then toggle the shipping "ON."</li>
          <li>Tap domestic, then Select "Ship with Depop"</li>
          <li>Enter your shipping address, then confirm it</li>
          <li>Tap "Package Size"</li>
          <li>Choose the approximate size of your item.</li>
          <li>After inputting these details, it will automatically set the shipping price for your item.</li>
          <li>
            Tap "Who Pays?" You have two options. You can shoulder the shipping cost or let your buyers pay for the
            shipping fees.
          </li>
          <li>
            If you're going to offer free shipping, leave the price field at zero, then tap the right-hand corner of
            your screen.
          </li>
          <li>If the buyer pays for this shipping, enter the shipping price instead of leaving it at zero.</li>
          <li>Click "Save" and publish.</li>
        </ol>

        <p>Things to Remember:</p>
        <ul>
          <li>
            Buyer Pays for Shipping - When a buyer purchases your item, the item price and additional shipping cost will
            be deposited on your Paypal account.
          </li>
          <li>
            Seller Pays for Shipping - When you make a sale, the item price will be deposited on your PayPal account.
            The shipping cost and Depop fee will be deducted in one transaction.
          </li>
        </ul>

        <h3>Packaging and Shipping Label Costs</h3>
        <p>
          You should also consider the packaging and shipping label costs as a seller. For starters, here is the step by
          step guide on how to generate your shipping labels:
        </p>

        <h4>Generate Shipping Labels on Depop:</h4>
        <ol>
          <li>Go to your profile, then tap "Sold Items," then click the item sold</li>
          <li>Tap "Activate Shipping Label"</li>
          <li>A PDF file of the shipping label will prompt.</li>
          <li>Click "Print" to print it from your phone or email.</li>
          <li>Stick the shipping label to your package using clear packaging tape.</li>
          <li>Drop it off at the nearest post office or USPS collection box</li>
        </ol>

        <h4>Shipping Label Costs</h4>
        <p>The prices are subject to changes depending on the courier, but here are the estimated prices:</p>
        <ul>
          <li>Extra- Small: $3.75 (First class and is less than 4oz)</li>
          <li>Small - $4.75 (First class and is less than 8oz)</li>
          <li>Medium - $6.75 (First class and is less than 1lb)</li>
          <li>Large - $11 (Priority mail that is less than 2lb)</li>
          <li>Extra Large - $15 (Priority mail that is less than 10lb)</li>
        </ul>
        <p>
          <strong>Update:</strong> Effective 2022, U.S. Ship with Depop prices using USPS have increased. Here are the
          new shipping rates:
        </p>
        <ul>
          <li>Extra-Small: Items weighing less than 4oz - $4.05</li>
          <li>Small: Items weighing less than 8oz - $5.05</li>
          <li>Medium: Items weighing less than 16oz - $7.05</li>
          <li>Large: Items weighing less than 2lb - $11.75</li>
          <li>Extra-Large: Items weighing less than 10lb - $15.75</li>
        </ul>
        <p>
          Evri (formerly known as Hermes) has also increased its shipping prices for U.K. sellers effective April 11,
          2022. Here's what the new rates look like:
        </p>
        <ul>
          <li>Small: Items less than 1kg - £3.15</li>
          <li>Medium: Items less than 2kg - £4.50</li>
          <li>Large: Items less than 5kg - £6.65</li>
          <li>Small Courier Collect: Items less than 1kg - £3.80</li>
          <li>Medium Courier Collect: Items less than 2kg - £5.25</li>
          <li>Large Courier Collect: Items less than 5kg - £6.65</li>
        </ul>

        <h3>Other Depop Selling Fees</h3>
        <p>
          Before posting and pricing your items, you must consider other Depop selling fees and PayPal transaction
          costs. Depop does not have subscription or listing fees, but they charge a 10% flat rate on every item sold.
          It simply means that in a $100 item sold, $10 goes to Depop.
        </p>
        <p>
          The 10% fee is not a listing fee nor a subscription fee from Depop. It consists of many things inside the
          Depop to help you sell and connect you with genuine buyers interested in your item.
        </p>
        <ul>
          <li>
            Marketing - Depop helps you connect with the right buyers interested and ready to buy your item. Simply
            input the right product title, production description, and other relevant attributes, and you're good to go.
          </li>
          <li>
            Fun and productive Depop community - Apart from the shopping app, Depop also has physical spaces in Los
            Angeles and New York City. They also run regular workshops and events to learn how to use Depop to attract
            more buyers to your shop.
          </li>
          <li>
            Your information is kept confidential - Depop is all about privacy. They do not sell your data or offer any
            advertising. Your information is kept safe.
          </li>
        </ul>

        <h3>Paypal Transaction Fee</h3>
        <p>
          Aside from the 10% fee from Depop, PayPal also charges transaction fees to ensure the safety of both buyers
          and sellers. The Paypal fee varies depending on which country you are located in.
        </p>
        <ul>
          <li>For US Sellers they charge 2.9% + $0.20</li>
          <li>For UK and EU Sellers it is 3.4% + $0.25</li>
        </ul>
        <p>
          PayPal transaction fees also include buyer and seller protection against fraud and scams. The transaction will
          go through Paypal first, and once the buyer receives their item, the money will be credited to your account.
          This ensures that you will get paid for the item you ship, and the buyer will also have an assurance that she
          will receive the item she bought from you. Always remember to use tracked delivery because untracked parcels
          are unwarranted by Depop or PayPal's seller protection policy.
        </p>

        <h3>Pricing Your Items Right!</h3>
        <p>
          It is vital to know and understand the basics to provide the right pricing for your items. With the right tone
          of voice, product description, and appealing photos- you can convert one to a hundred sales in no time!
        </p>
        <h4>1. Check the Market Price</h4>
        <p>
          You can price your item based on the market price. Just remember that size, color, and condition can alter its
          value. You can browse the Depop app to see your competitor's price and then set your pricing.{' '}
        </p>
        <h4>2. Materials and Running Costs</h4>
        <p>
          If you are the maker, consider the materials used and other costs when making the item. Add the labor cost or
          the time it took to make the item.
        </p>
        <h4>3. Adjust it Accordingly</h4>
        <p>
          If you are receiving many "likes" but little to no buyers, you may want to adjust your pricing. You might have
          priced it too high for your buyers.
        </p>
        <h4>4. Let Buyers Make Offers</h4>
        <p>
          If you are not sure if you price it right for your customers, let your buyers make offers or negotiations
          until you find the price you are happy and satisfied with.
        </p>
        <h4>5. If You Are Not Satisfied With The Price, Don't Sell it.</h4>
        <p>
          If you feel like you are pricing the item lower than its market price or feels like the price is not enough,
          then don't sell it.
        </p>

        <h3>Elevate Your Selling Tactics!</h3>
        <p>
          Every business has its ups and downs. There are times when you have no sale, then the next day you get ten.
          But that doesn't mean you shouldn't do anything about it. You can elevate your selling on various marketplaces
          and shopping platforms like Poshmark, Depop, Mercari, and more!
        </p>
        <p>
          OneShop offers sellers the easiest and most effective way to get more buyers, save time, and do other things
          you love doing the most! We provide easy guidelines on how to sell effectively and eventually make more sales!
          Plus, our all-in-one app saves you plenty of time while selling on multiple marketplaces.{' '}
        </p>
        <p>
          With OneShop, you can upload your product images and quickly draft your listings. You can cross-list to
          multiple marketplaces integrated into our system ( Poshmark, Mercari, Tradesy, and eBay.) Have you
          accidentally listed a single listing on two separate marketplaces? Worry no more, as OneShop will
          automatically delist your item once sold on another platform. Never worry about after-sales again.
        </p>
        <p>
          To learn more about how OneShop helps sellers win the marketplaces and helps you achieve your business goals,{' '}
          <a href='https://tools.oneshop.com/signup'>sign-up here</a> and learn how to succeed in your business with our
          7-day free trial!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
